import {type Dispatch, type SetStateAction, useEffect, useLayoutEffect, useState} from "react";

const STORAGE_KEY = "semantic_search_floating_sidebar_open";

const readFromStorage = (): boolean | null => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);

        if (raw === "true") return true;
        if (raw === "false") return false;
    } catch {
        console.error("Error reading localStorage for semantic search");
    }

    return null;
};

const writeToStorage = (isOpen: boolean) => {
    try {
        window.localStorage.setItem(STORAGE_KEY, String(isOpen));
    } catch {
        console.error("Error writing to localStorage for semantic search");
    }
};

/**
 * Open/closed state for the floating AI advisor sidebar, persisted in localStorage.
 * Defaults to `true` when nothing is stored.
 */
export const usePersistedFloatingSemanticSearchSidebarOpen = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
    const [isOpen, setIsOpen] = useState(true);

    useLayoutEffect(() => {
        const stored = readFromStorage();

        if (stored !== null) {
            setIsOpen(stored);
        }
    }, []);

    useEffect(() => {
        writeToStorage(isOpen);
    }, [isOpen]);

    return [isOpen, setIsOpen];
};
import {type Dispatch, type SetStateAction, useEffect, useLayoutEffect, useState} from "react";

const STORAGE_KEY = "semantic_search_floating_sidebar_open";

const readFromStorage = (): boolean | null => {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);

        if (raw === "true") return true;
        if (raw === "false") return false;
    } catch {
        console.error("Error reading localStorage for semantic search");
    }

    return null;
};

const writeToStorage = (isOpen: boolean) => {
    try {
        window.localStorage.setItem(STORAGE_KEY, String(isOpen));
    } catch {
        console.error("Error writing to localStorage for semantic search");
    }
};

/**
 * Open/closed state for the floating AI advisor sidebar, persisted in localStorage.
 * Defaults to `true` when nothing is stored.
 */
export const usePersistedFloatingSemanticSearchSidebarOpen = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
    const [isOpen, setIsOpen] = useState(true);

    useLayoutEffect(() => {
        const stored = readFromStorage();

        if (stored !== null) {
            setIsOpen(stored);
        }
    }, []);

    useEffect(() => {
        writeToStorage(isOpen);
    }, [isOpen]);

    return [isOpen, setIsOpen];
};
